import React, { createContext, useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import Interceptor from '../core/type/operation/Interceptor';
import { DataContext } from './DataContext';
import TextInputType from '../core/type/input/TextInputType';
import SelectorInputType from '../core/type/input/SelectorInputType';
import ButtonInputType from '../core/type/input/ButtonInputType';
import RangeSelectorType from '../core/type/input/RangeSelectorType';
import RaterInputType from '../core/type/input/RaterInputType';
import Switch from '../core/type/operation/Switch';
import NodeCheckpoint from '../core/type/operation/NodeCheckpoint';
import BotDialogType from '../core/type/dialog/BotDialogType';
import { randomGoBackMessage } from '../util/bot-utils';
import SeletorProjetoInputType from '../core/type/input/SeletorProjetoInputType';

export const OrchestratorContext = createContext();

const OrchestratorProvider = ({ children, script }) => {
  const [runner, setRunner] = useState([]);
  const [history, setHistory] = useState([]);

  const [runnerPrevious, setRunnerPrevious] = useState([]);

  const context = useContext(DataContext);
  const { data, setData } = context;

  useEffect(() => {
    async function fetchData() {
      runner.unshift(...script);
      const nextElement = runner.shift();
      setRunner(runner);
      setRunnerPrevious([nextElement]);

      if (nextElement instanceof Interceptor) {
        // interceptorExecution(nextElement);
        const updatedData = await nextElement.run(data, setData);
        setData(updatedData);
        setHistory([...history, nextElement]);
        next(updatedData);
      } else {
        setHistory([...history, nextElement]);
      }
    }
    fetchData();
  }, []);

  const transformSwitchInScript = (nextElement) => {
    let scriptReturn = [];
    scriptReturn = nextElement.cases.filter(
      (caseItem) => {
        const elem = nextElement.ref;
        let variable;
        if (elem.includes('.')) {
          const elemParts = elem.split('.');

          variable = data[elemParts[0]][elemParts[1]];
        } else {
          variable = data[elem];
        }

        let express;

        if (variable instanceof Object) {
          express = caseItem.express.replace(new RegExp('\\$v', 'g'), variable.key || variable.value);
        } else {
          express = caseItem.express.replace(new RegExp('\\$v', 'g'), variable);
        }
        /* eslint-disable */
        const verify = eval(express);
        return verify;
      },
    );

    if (scriptReturn.length === 0) {
      return nextElement.caseDefault;
    }

    scriptReturn = scriptReturn.map((caseItem) => caseItem.components)
      .reduce((acc, nextItem) => [...acc, ...nextItem]);

    scriptReturn.unshift(new NodeCheckpoint({}));
    scriptReturn.push(new NodeCheckpoint({ end: true }));

    return scriptReturn;
  };

  const next = async (value) => {
    const nextElement = runner.shift();
    setRunner([...runner]);

    const previousElement = history[history.length - 1];
    const newData = _.cloneDeep(data)
    if (
      previousElement instanceof TextInputType
      || previousElement instanceof SelectorInputType
      || previousElement instanceof ButtonInputType
      || previousElement instanceof RangeSelectorType
      || previousElement instanceof RaterInputType
      || previousElement instanceof SeletorProjetoInputType
    ) {
      const { key } = previousElement;
      newData[key] = value;
      setData({ ...newData });
      history.splice(history.length - 1, 1);
    }

    runnerPrevious.push(nextElement);
    setRunnerPrevious(runnerPrevious);

    switch (nextElement.constructor) {
      case Interceptor:
        const t = { ...newData }
        const updatedData = await nextElement.run(t, setData);
        setData({ ...updatedData })
        setHistory([...history, nextElement]);
        next({ ...updatedData });
        break;
      case Switch:
        runner.unshift(...transformSwitchInScript(nextElement));
        setRunner(runner);
        next();
        break;
      case NodeCheckpoint:
        next();
        break;
      default:
        setHistory([...history, nextElement]);
        break;
    }
  };

  const returnCheckpoint = () => {
    let nextPrevious = true;
    let notFirst = false;

    while (nextPrevious) {
      const previous = runnerPrevious.pop();

      if (previous === undefined) {
        return false;
      }

      setRunnerPrevious(runnerPrevious);

      if (previous instanceof BotDialogType && previous.checkpoint === true) {
        if (notFirst) {
          nextPrevious = false;
        } else {
          notFirst = true;
        }
        runner.unshift(previous);
        runner.unshift(new BotDialogType({
          message: randomGoBackMessage(),
          goBackMessage: true,
        }));
        setRunner(runner);
        next();
      } else if (previous instanceof BotDialogType && previous.goBackMessage === true) {
        setRunner(runner);
      } else {
        runner.unshift(previous);
        setRunner(runner);
        if (previous instanceof Switch) {
          let nodeCheckpoint = false;

          const newRunner = runner.filter((obj) => {
            if (obj instanceof NodeCheckpoint && obj.end === false) {
              nodeCheckpoint = true;
              return false;
            } if (obj instanceof NodeCheckpoint && obj.end === true) {
              nodeCheckpoint = false;
              return false;
            }

            return !nodeCheckpoint;
          });

          while (runner.length) {
            runner.pop();
          }

          runner.unshift(...newRunner);
          setRunner(runner);
        }
      }
    }

    return true;
  };

  return (
    <OrchestratorContext.Provider value={{ history, next, returnCheckpoint }}>
      {children}
    </OrchestratorContext.Provider>
  );
};

export default OrchestratorProvider;
